<template>
  <div class="wrapper">
    
      <div class="section section-signup page-header header-filter" :style="headerStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
            >
          <div>
            <md-button
              class=" md-danger md-round btnA"
              color="red"
              href="#/basic"
              >Retour</md-button
            >
            <md-button @click="generateReport" class=" md-danger md-round btnA">
                      Extraction
                    </md-button>
          </div>
          <md-table
            md-card
            md-sort="name"
            md-sort-order="asc"
            v-model="volunteers"
            :md-fixed-header="false"
            class="tab"
          >
            <md-table-toolbar>
              <div class="md-toolbar-section-start">
                <md-field>
                  <label for="selectedMois">Selectionner l'année</label>
                  <md-select
                    id="selectedYear"
                    name="selectedYear"
                    v-model="query.year"
                    :disabled="isDisabled"
                  >
                    <md-option :key="year" :value="year" v-for="year in years">
                      {{ year }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-toolbar-section-start">
                <md-field>
                  <label for="selectedMois">Selectionner le mois</label>
                  <md-select
                    v-model="query.month"
                    :disabled="isDisabled"
                    name="selectedMois"
                    id="selectedMois"
                  >
                    <md-option value="1">Janvier</md-option>
                    <md-option value="2">Février</md-option>
                    <md-option value="3">Mars</md-option>
                    <md-option value="4">Avril</md-option>
                    <md-option value="5">Mai</md-option>
                    <md-option value="6">Juin</md-option>
                    <md-option value="7">Juillet</md-option>
                    <md-option value="8">Août</md-option>
                    <md-option value="9">Septembre</md-option>
                    <md-option value="10">Octobre</md-option>
                    <md-option value="11">Novembre</md-option>
                    <md-option value="12">Décembre</md-option>
                  </md-select>
                </md-field>
              </div>

              <md-field md-clearable class="md-toolbar-section-end">
                <md-input
                  v-model="query.search"
                  placeholder="Search by name..."
                />
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Nom" md-sort-by="nom">
                {{ item.nom_antenne }}
              </md-table-cell>

              <md-table-cell
                md-label="Heures du mois"
                md-sort-by="totalHoursOfMonth"
              >
                {{
                  item.totalHoursOfMonth === "00:00:00"
                    ? "-"
                    : item.totalHoursOfMonth
                }}
              </md-table-cell>

              <md-table-cell
                md-label="Heures dans l'année"
                md-sort-by="totalHoursOfYear"
              >
                {{
                  item.totalHoursOfYear === "00:00:00"
                    ? "-"
                    : item.totalHoursOfYear
                }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import axios from "../../http-common";
import * as XLSX from "xlsx/xlsx.mjs";
const currentDate = new Date();

export default {
  bodyClass: "login-page",
  name: "Volunteers",
  data: () => ({
    volunteers: [],
    activites: [],
    years: [],
    query: {
      limit: 4485,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      search: "",
    },
  }),

  props: {
    header: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },

  watch: {
    query: {
      handler() {
        this.debouncedLoadVolunteers();
      },
      deep: true,
    },
  },

  methods: {
    loadVolunteers() {
      try {
        axios
          .get(
            `/byAntenne?limit=${this.query.limit}&search=${this.query.search}&year=${this.query.year}&month=${this.query.month}`
          )
          .then((response) => {
            const volunteers = response.data.data.volunteers;
            this.volunteers = volunteers;
          });
      } catch (error) {
        //console.error({ error: error.message });
      }
    },
     async generateReport() {
      /* flatten objects */
      let rows = this.volunteers.map((row) => ({
        nom_antenne: row.nom_antenne,
       
        totalHoursOfMonth: row.totalHoursOfMonth,
        totalHoursOfYear: row.totalHoursOfYear,
      }));

      rows.unshift({
        nom_antenne: "Nom",
        
        totalHoursOfMonth: "Heure total du mois",
        totalHoursOfYear: "Heure total dans l'année",
      });

      /* generate worksheet and workbook */
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet);

      /* fix headers */
      XLSX.utils.sheet_add_aoa(worksheet, [["", "", "", "", ""]], {
        origin: "A1",
      });

      /* calculate column width */
      const max_width = rows.reduce((w, r) => Math.max(w, r.nom_antenne.length), 20);
      worksheet["!cols"] = [
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];

      /* create an XLSX file and try to save to repport.xlsx */
      XLSX.writeFile(workbook, "repport.xlsx", { compression: true });
    },

    prepareYear() {
      for (let i = 2023; i <= new Date().getFullYear(); i++) {
        this.years.push(i);
      }
    },
  },

  mounted() {
    this.loadVolunteers();
  },

  created() {
    this.debouncedLoadVolunteers = debounce(this.loadVolunteers, 500);
    this.prepareYear();
  },
};
</script>

<style lang="scss" scoped>
.md-field {
  margin: auto;
  max-width: 300px;
}
.btnA {
  margin-top: 50px;
  margin-bottom: -200px;
}
.tab {
  padding-top: -60px;
}
</style>
